import { safeStorage } from './safeStorage';
/**
 * Safe localStorage utilities that work in both browser and React Native contexts
 * 
 * These functions prevent "localStorage is not an object" errors when running
 * in React Native or server-side rendering environments.
 */

/**
 * Safely get an item from localStorage
 * @param {string} key - The localStorage key
 * @returns {string|null} - The value or null if not available/found
 */
export function safeGetItem(key) {
  return safeStorage.getItem(key);
}

/**
 * Safely set an item in localStorage
 * @param {string} key - The localStorage key
 * @param {string} value - The value to store
 * @returns {boolean} - True if successful, false otherwise
 */
export function safeSetItem(key, value) {
  safeStorage.setItem(key, value);
  return true;
}

/**
 * Safely remove an item from localStorage
 * @param {string} key - The localStorage key
 * @returns {boolean} - True if successful, false otherwise
 */
export function safeRemoveItem(key) {
  safeStorage.removeItem(key);
  return true;
}

/**
 * Get current auth token safely
 * @returns {string|null} - The auth token or null if not available
 */
export function getAuthToken() {
  return safeGetItem('evv_token');
}

/**
 * Get current user data safely
 * @returns {Object|null} - Parsed user object or null if not available
 */
export function getUserData() {
  try {
    const userData = safeGetItem('evv_user');
    return userData ? JSON.parse(userData) : null;
  } catch (error) {
    console.warn('Failed to parse user data from localStorage:', error);
    return null;
  }
}